export default "__VITE_ASSET__faef091d__"